import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.less';
import {Divider, Avatar} from 'antd';
import {getCard} from '@/api/conversation';

export default function UserCard({userId, corpName}) {
    const [card, setCard] = useState(null);
    useEffect(() => {
        init();
    }, [userId]);

    function init() {
        getCard(userId).then(res => {
            setCard(res.data);
        });
    }

    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <Avatar src={card ? card.avatar : ''} className={styles.avatar} />
                <div>
                    <div className={styles.title}>{card ? card.name : '未知联系人'}</div>
                    <div className={styles.subTitle}>{corpName}</div>
                </div>
            </div>
            <Divider style={{margin: '20px 0'}} />
            <div className={styles.foot}>个人名片</div>
        </div>
    );
}

UserCard.propTypes = {
    userId: PropTypes.string,
    corpName: PropTypes.string,
};
